namespace $.$$ {

	/**
	 * @deprecated Legacy in-app password form. Use `$shm_hitalama_entergate` through `/login`.
	 */
	export class $shm_hitalama_profile_enter extends $.$shm_hitalama_profile_enter {

		@ $mol_mem
		login( next?: string ): string {
			this.message('')
			return next ?? ''
		}

		@ $mol_mem
		passwond( next?: string ): string {
			this.message('')
			return next ?? ''
		}
		
		@ $mol_mem
		pull_pass_keys( ) {
			this.profiles()?.keys().forEach( k => {
				try {
					this.profiles().key(k)?.remote()?.Pass_key()?.val() 
				} catch (error) {
					console.log( error )
				}
			} )
		}
		
		submit( next?: any ) {
			const profiles = this.profiles()
			if( !profiles ) {
				this.message( this.message_incorrect_pass() )
				return
			}

			let profile = profiles.key( this.login() )?.remote()
			if( !profile && this.login() === 'admin' && this.passwond() === 'admin' && this.$.$shm_hitalama_settings.selfhosted_tauri_enabled() ) {
				profile = profiles.key( this.login(), 'auto' )?.remote( this.$.$shm_hitalama_profile.current() )
				profile?.Login(null)!.val( this.login() )
				profile?.version( $shm_hitalama_profile_migration.latest_version() )
				profile?.password( this.passwond() )
				profile?.selfhosted_defaults_ensure()
			}

			if( profile?.enter( this.passwond() ) ) {
				this.$.$shm_hitalama_app.selfhosted_tauri_logout( false )
				this.$.$mol_state_arg.value( 'section', null )
				return
			}

			this.message( this.message_incorrect_pass() )
		}

		@ $mol_mem
		message( next?: string ): string {
			return next ?? ''
		}
		
	}

}
